import { DecimalPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { AlertController, ModalController, Platform } from "ionic-angular";
import moment from "moment";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { convertToVoiceTextarea } from "../../../../utils/convert-to-voice-textarea";

const dateTimeFormat = "MM/DD/YYYY HH:mm";

/**
 * Generated class for the NarrativeListCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "narrative-list-card",
  templateUrl: "narrative-list-card.html",
})
export class NarrativeListCardComponent implements OnInit {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;

  id: string;
  label: string;
  componentId: string;
  access: string;
  tooltip: object;
  colHeaders: string[];
  deltaFields: string[];

  rawData: any[] = [];
  dataRows: any[] = [
    // {
    //     origin: "Cardiovascular",
    //     category: "Pacemaker",
    //     description: "The sound of a polka drifted from my neighbor's\n" +
    //     "And set my feet a-tapping oh!\n" +
    //     "Ieva's mother had her eye on her daughter but\n" +
    //     "Ieva she managed to fool her, you know.\n" +
    //     "'Cause who's going to listen to mother saying no\n" +
    //     "When we're all busy dancing to and fro!\n" +
    //     "\n" +
    //     "Ieva was smiling, the fiddle it was wailing\n" +
    //     "As people crowded round to wish her luck.\n" +
    //     "Everyone was hot but it didn't seem to bother\n" +
    //     "The handsome young man, the dashing buck.\n" +
    //     "'Cause who's going to mind a drop of sweat\n" +
    //     "When he's all busy dancing to and fro!\n" +
    //     "\n" +
    //     "Ieva's mother she shut herself away\n" +
    //     "In her own quiet room to hum a hymn.\n" +
    //     "Leaving our hero to have a spot of fun\n" +
    //     "In a neighbor's house when the lights are dim.\n" +
    //     "'Cause what does it matter what the old folks say\n" +
    //     "When you're all busy dancing to and fro!\n" +
    //     "\n" +
    //     "When the music stopped then the real fun began\n" +
    //     "And that's when the laddie fooled around.\n" +
    //     "When he took her home, when the dancing was over\n" +
    //     "Her mother angrily waiting they found.\n" +
    //     "But I said to her, Ieva, now don't you weep\n" +
    //     "And we'll soon be dancing to and fro!\n" +
    //     "\n" +
    //     "I said to her mother now stop that noise\n" +
    //     "Or I won't be responsible for what I do.\n" +
    //     "If you go quietly and stay in your room\n" +
    //     "You won't get hurt while your daughter I woo.\n" +
    //     "'Cause this fine laddie is a wild sort of guy\n" +
    //     "When he's all busy dancing to and fro!\n" +
    //     "\n" +
    //     "One thing I tell you is you won't trap me,\n" +
    //     "No, you won't find me an easy catch.\n" +
    //     "Travel to the east and travel to the west but\n" +
    //     "Ieva and I are going to make a match.\n" +
    //     "'Cause this fine laddie ain't the bashful sort\n" +
    //     "When he's all busy dancing to and fro",
    //     author: "Dr. Mario",
    //     date: "20171129T174945-0500"
    // }
  ];
  // dummyRow: object;
  prevRow: {};
  declinable: boolean;
  editable: boolean = false;

  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;

  headerField: string;
  subheaderField: string;
  textField: string;
  footerField: string;
  subfooterField: string;

  truncateLength = 300;

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    private alertCtrl: AlertController,
    public translatePipe: TranslateService
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label = this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.deltaFields = this.config.data.deltaFields || [];
    this.declinable = this.config.declinable;
    if (this.config.editable) {
      this.editable = this.config.editable;
    }

    this.headerField = this.config.headerField;
    if (this.config.subheaderField) {
      this.subheaderField = this.config.subheaderField;
    }
    // console.log( "Headers: ", this.headerField, this.subheaderField );
    this.textField = this.config.textField;
    // console.log( "Text field: ", this.textField );
    this.footerField = this.config.footerField;
    if (this.config.subfooterField) {
      this.subfooterField = this.config.subfooterField;
    }
    // console.log( "Footers: ", this.footerField, this.subfooterField );

    // this.dummyRow = { id: "" };
    // let dummyData = {};
    // for (let header of this.colHeaders) {
    //     dummyData[header] = "-";
    // }
    // this.dummyRow['values'] = dummyData;
  }

  @Input() set data(incomingData: any) {
    // console.log( "Form card Data: ", this.data );
    // console.log( "Form card Incoming data: ", incomingData );
    if (incomingData) {
      let cardData = incomingData;

      // Call some service to load rows and prevRow
      this.dataRows = [];
      if (cardData.data) {
        this.rawData = cardData.data;
        for (let data of cardData.data) {
          let info = { id: data.id };
          let values = this.parseDataRow(data);
          info["values"] = values;
          this.dataRows.push(info);
        }
      }

      this.updateDataPages();
    }
  }

  presentListForm(): void {
    let newConfig;
    try {
      newConfig = JSON.parse(JSON.stringify(this.config));
    } catch (e) {
      newConfig = this.config;
    }

    let config = { config: newConfig };

    // Convert to voiceTextarea if needed
    config = convertToVoiceTextarea(config);

    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined) {
        this.addData(data);
      }
    });
    listModal.present();
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] == "object" && data[key] !== null) {
        let innerObj = data[key];
        for (let innerKey of Object.keys(innerObj)) {
          let newKey = key + innerKey.replace(/\b\w/g, (l) => l.toUpperCase());
          flatData[newKey] = innerObj[innerKey];
        }
      } else {
        if (data[key] !== null) {
          flatData[key] = data[key];
        }
      }
    }
    // console.log( "FLATTENED IT: ", flatData );
    return flatData;
  }

  parseDataRow(data: object) {
    let values = {};
    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      // console.log( "Checking header: ", header );
      let val = "-";
      if (flatData[header]) {
        if (header === "date") {
          flatData[header] = moment(flatData[header]).format(dateTimeFormat);
        }
        val = flatData[header];
      }
      // console.log( "Produced val: ", val );
      values[header] = val;
    }
    return values;
  }

  addData(data: any): void {
    //console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .storeRecord(this.assessmentId, this.sectionId, this.id, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from submission:", returnData );
            if (!returnData) {
              return;
            }

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            //console.log("Pushing new val.", newData);
            data["id"] = returnData.id;
            this.rawData.unshift(data);
            this.dataRows.unshift(newData);
            this.updateDataPages();
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  editRow(row: object): void {
    // console.log( "Editing row: ", row );
    // console.log( "Raw data: ", this.rawData ); // TODO : Clean Me up!

    let modalConfig = { config: this.config };

    let values = this.rawData.filter((record) => record.id == row["id"])[0];
    if (values !== null && values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};

      for (let key of inputKeys) {
        if (values[key]) {
          editData[key] = values[key];
        } else {
          editData[key] = null;
        }
      }
      modalConfig["data"] = editData;
    }

    // Convert to voiceTextarea if needed
    modalConfig = convertToVoiceTextarea(modalConfig);

    // console.log( "Launching edit with modal config: ", modalConfig );
    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      // console.log( "GOT DATA BACK!:" );
      // console.log(data);

      if (data !== undefined) {
        this.editData(row, row["id"], data);
      }
    });
    listModal.present();
  }

  editData(oldRow: object, rowId: string, data: any): void {
    // console.log( "Data being pushed:" , data );
    if (data) {
      try {
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            //console.log( "Data returned from edit:", returnData );

            let newData = { id: returnData.id };
            newData["values"] = this.parseDataRow(returnData);

            let rawData = this.rawData;
            for (let index in rawData) {
              if (rawData[index]["id"] === returnData.id) {
                rawData[index] = returnData;
                break;
              }
            }
            // console.log( "Updated rawData: ", this.rawData );

            //console.log("Pushing new val.", newData);
            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDataPages();
          });
      } catch (error) {
        //console.log( "Error during data submission and building.", error );
      }
    }
  }

  deleteRow(id: string) {
    //console.log( "I'm going to delete: ", id );

    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            //console.log( "I'm going to delete: ", id );
            this.dataService
              .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
              .subscribe(() => {
                //console.log( "Removing rows that match: ", id );

                this.rawData = this.rawData.filter((row) => row.id !== id);
                this.dataRows = this.dataRows.filter((row) => row.id !== id);
                this.updateDataPages();
              });
          },
        },
      ],
    });
    alert.present();
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    // if( pageIndex > 0 ) {
    //     let endingRow = dataRows.length % pageSize;
    //     if( endingRow > 0 ) {
    //         for( let i = endingRow; i < pageSize; i++ ) {
    //             dataPages[pageIndex][i] = this.dummyRow;
    //         }
    //     }
    // }

    if (this.currentPage > dataRows.length % pageSize) {
      this.prevPage();
    }
    // console.log( "Produced pages: ", this.dataPages );
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    if (
      page >= 0 &&
      page <= this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/narrative-list-card/narrative-list-card.ts